import {
  faCalendarDays,
  faIndustry,
  faMarker,
} from '@fortawesome/free-solid-svg-icons'
import createField from '../../../utils/factory/createField'
import {
  fa42Group,
  faProductHunt,
  faTypo3,
} from '@fortawesome/free-brands-svg-icons'

export const filterFields = [
  {
    section: 'Filtros para o relatório',
    fields: [
      createField({
        id: 'filter.start_date',
        label: 'Periodo de entrada de',
        placeholder: 'Selecione o periodo de inicio',
        type: 'date',
        icon: faCalendarDays,
      }),
      createField({
        id: 'filter.end_date',
        label: 'Periodo de entrada até',
        placeholder: 'Selecione o periodo de fim',
        type: 'date',
        icon: faCalendarDays,
      }),
      createField({
        id: 'filter.supplier_id',
        label: 'Fornecedor',
        placeholder: 'Selecione o fornecedor',
        type: 'select',
        isMulti: true,
        icon: faIndustry,
      }),
      createField({
        id: 'filter.product_id',
        label: 'Produto',
        placeholder: 'Selecione o produto',
        type: 'select',
        isMulti: true,
        icon: faProductHunt,
      }),
      createField({
        id: 'filter.type_id',
        label: 'Tipo',
        placeholder: 'Selecione o tipo do produto',
        type: 'select',
        isMulti: true,
        icon: faTypo3,
      }),
      createField({
        id: 'filter.group_id',
        label: 'Grupo',
        placeholder: 'Selecione o grupo do produto',
        type: 'select',
        isMulti: true,
        icon: fa42Group,
      }),
      createField({
        id: 'filter.brand_id',
        label: 'Marca',
        placeholder: 'Selecione a marca do produto',
        type: 'select',
        fullWidth: true,
        isMulti: true,
        icon: faMarker,
      }),
    ],
  },
]
